export default function AboutSection() {
  const values = [
    {
      icon: "ri-shield-check-line",
      title: "Security First",
      desc: "Every product we build is engineered with privacy and security as the foundation, not an afterthought.",
    },
    {
      icon: "ri-speed-up-line",
      title: "Performance Driven",
      desc: "We obsess over speed, efficiency, and smooth user experiences across all iOS devices.",
    },
    {
      icon: "ri-lightbulb-line",
      title: "Innovation Focused",
      desc: "Our team continuously explores new technologies to deliver cutting-edge mobile solutions.",
    },
    {
      icon: "ri-user-heart-line",
      title: "User Centric",
      desc: "Intuitive design and seamless usability are at the core of every application we release.",
    },
  ];

  return (
    <section id="about" className="w-full bg-[#F7F6F2] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 mb-20">
          <div className="lg:w-1/2">
            <p className="text-xs font-semibold tracking-[0.2em] text-gray-400 uppercase mb-4">/ About Us</p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              A Team of iOS<br />Experts Building<br />What Matters
            </h2>
          </div>
          <div className="lg:w-1/2 flex flex-col justify-center">
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
              BAZA DOO BECEJ is a dedicated software development company based in Serbia, specializing exclusively in the iOS platform. We bring together seasoned engineers, designers, and product strategists to create applications that genuinely improve people&apos;s digital lives.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              From enterprise-grade VPN solutions to intelligent device cleaners, our products are trusted by tens of thousands of users who demand reliability, privacy, and performance from their mobile tools.
            </p>
          </div>
        </div>

        {/* Team image */}
        <div className="w-full rounded-3xl overflow-hidden mb-20 h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/a337ee3c202756da0524146d247b06d2.jpg"
            alt="BAZA DOO BECEJ team workspace"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div
              key={v.title}
              className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-gray-200 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-xl mb-4">
                <i className={`${v.icon} text-white text-lg`} />
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-2">{v.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
